module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.ticket != '-1' && _vm.ticket) ? _c('div', {
    staticClass: "tableau",
    style: ({
      zoom: _vm.getZoom
    })
  }, [_c('Tableau', {
    ref: "meetingTableau",
    attrs: {
      "url": _vm.url,
      "width": _vm.width,
      "height": _vm.height
    }
  })], 1) : (_vm.ticket == '-1') ? _c('div', [_c('error-section')], 1) : _c('div')
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-415a0751", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-415a0751","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/dashboard/meeting/index.vue
// module id = 1567
// module chunks = 7